module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[61]304.7f5766c.woff2";